<div 
  *ngIf="heroContent"
  class="hero-section-wrapper"
  data-test="hero-section"
  [ngClass]="bgPosition"
  [ngStyle]="{
    'background-image': isMobile && heroContent.mobileImageUrl
      ? 'url(' + heroContent.mobileImageUrl + ')'
      : 'url(' + heroContent.imageUrl + ')'
  }"
  >
  <div
    *ngIf="heroContent.videoUrl && !isMobile"
    class="highlight-video-container position-absolute d-none d-md-block"
    data-test="hero-highlight-video"
    >
    <video
      class="highlight-video"
      autoplay
      muted
      loop
      data-test="highlight-video"
      oncanplay="play()"
      onloadedmetadata="muted = true"
      >
      <source [src]="heroContent.videoUrl" type="video/mp4" />
    </video>
  </div>

  <div class="content-wrapper w-100 container" data-test="paywall-content-wrapper">
      <div class="title-content mb-3">
        <h1 
          class="display-1 color-100 font-family-book"
          data-test="hero-title"
          [innerHTML]="liveEventHeader && liveEventHeader.title ? liveEventHeader.title : heroContent.title">
        </h1>
        <p
          data-test="hero-subtitle"
          class="mt-35 color-100 font-family-thin"
          [innerHTML]="liveEventHeader && liveEventHeader.subtitle ? liveEventHeader.subtitle : heroContent.subtitle">
        </p>
      </div>
      <button
        events="click"
        name="Sign Up"
        class="btn btn-primary btn-lg lg-font-btn"
        data-test="paywall-button"
        (click)="handleClick()"
        >
        Sign Up
      </button>
  </div>
</div>